import { ReactElement } from "react";
import styles from "./SerialNumberLoader.module.scss";

const SerialNumberLoader = (): ReactElement => {
    return <h1 className={styles.serialNumberLoader}>Checking S/N...</h1>;
};

export default SerialNumberLoader;
